"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FloatingPositions = exports.FloatingUIModes = void 0;
var FloatingUIModes;
(function (FloatingUIModes) {
    FloatingUIModes["MediaLoaded"] = "MediaLoaded";
    FloatingUIModes["OnDemand"] = "OnDemand";
    FloatingUIModes["Immediate"] = "Immediate";
    FloatingUIModes["FirstPlay"] = "FirstPlay";
})(FloatingUIModes = exports.FloatingUIModes || (exports.FloatingUIModes = {}));
var FloatingPositions;
(function (FloatingPositions) {
    FloatingPositions["VideoArea"] = "VideoArea";
    FloatingPositions["PresetArea"] = "PresetArea";
    FloatingPositions["InteractiveArea"] = "InteractiveArea";
})(FloatingPositions = exports.FloatingPositions || (exports.FloatingPositions = {}));
//# sourceMappingURL=floating-item-data.js.map